import request from '../utils/request';

export async function getCount(day, id) {
  return await request(`analysis/worktable?day=${day}&id=${id}`, 'get');
}